import logoSquareBlack from '@/assets/logo-square-black';
import { IconLoadingOutlined } from '@thisisdmg/tirecloud-patterns/v2/components/icons';
import classes from './index.module.css';
import { motion } from 'motion/react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export interface LoadingSpinnerBoxProps {
  overlay?: boolean;
}

export default function LoadingSpinnerBox({
  overlay = true,
}: LoadingSpinnerBoxProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      className={clsx(classes.loading_spinner_box, 'loading-spinner-box', {
        [classes.loading_spinner_box__overlay]: overlay,
      })}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 1,
      }}
    >
      <div className={classes.loading_spinner_box__icon_wrapper}>
        <IconLoadingOutlined
          spin
          className={classes.loading_spinner_box__icon}
        />
      </div>
      <img
        src={logoSquareBlack}
        alt={t('common.loading')}
        className={classes.loading_spinner_box__logo}
      />
    </motion.div>
  );
}
